"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
var domainSuggestionList = {
  "bol.com": "bol.com.br",
  "gmail.com.br": "gmail.com",
  "gmai.com": "gmail.com",
  "gmil.com": "gmail.com",
  "gamil.com": "gmail.com",
  "gmal.com": "gmail.com",
  "gemail.com": "gmail.com",
  "gmail.co": "gmail.com",
  "gamail.com": "gmail.com",
  "gmail.con": "gmail.com",
  "gmail.co.com": "gmail.com",
  "gmsil.com": "gmail.com",
  "ymail.com": "gmail.com",
  "email.com": "gmail.com",
  "gm.com": "gmail.com",
  "gmail.cm": "gmail.com",
  "g.com": "gmail.com",
  "gnail.com": "gmail.com",
  "gmeil.com": "gmail.com",
  "hotmai.com": "hotmail.com",
  "hormail.com": "hotmail.com",
  "hotmil.com": "hotmail.com",
  "hotmal.com": "hotmail.com",
  "hitmail.com": "hotmail.com",
  "hotmail.con": "hotmail.com",
  "hotmsil.com": "hotmail.com",
  "homail.com": "hotmail.com",
  "hotimail.com": "hotmail.com",
  "hmail.com": "hotmail.com",
  "hotmail.co": "hotmail.com",
  "htmail.com": "hotmail.com"
};
function isValidEmail() {
  var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (!email) return new classes_1.ValidationResult(true);
  var usernameEmail = email.split("@")[0];
  var domainEmail = email.split("@")[1];
  if (domainSuggestionList === null || domainSuggestionList === void 0 ? void 0 : domainSuggestionList[domainEmail]) {
    var sugestionEmailMessage = "Voc\xEA quis dizer ".concat(usernameEmail, "@").concat(domainSuggestionList[domainEmail], "?");
    return new classes_1.ValidationResult(false, sugestionEmailMessage);
  }
  var regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var noMatchSpecialChars = !email.match(/[~!#$%^&*()+=`{}[\]|\\:;'<>,?]/gi);
  var noAccents = !email.match(/[áàâãéèêíìîïóòôõöúùûçñÁÀÂÃÉÈÊÍÌÎÏÓÒÔÕÖÚÙÛÇÑ]/gi);
  var invalidEmailMessage = "Email inválido";
  if (email.indexOf("@-") > 0) {
    return new classes_1.ValidationResult(false, invalidEmailMessage);
  }
  var isValid = regExp.test(email) && noMatchSpecialChars && noAccents;
  var message = isValid ? "" : invalidEmailMessage;
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isValidEmail);